import { BaseServiceRequestDto } from "./dto/request/BaseServiceRequest.dto";

export interface IResponseError {
  error: boolean;
  message: string;
}

export interface IGetUserPrivileges extends BaseServiceRequestDto {
  user?: string;
}

export interface IUserPrivilegeItem {
  code: string;
  name: string;
  updatedAt: Date;
  enabled: boolean;
}

export interface IGetUserPrivilegesResponseData {
  user: string;
  privileges: IUserPrivilegeItem[];
}

export interface IGetUserPrivilegesResponseOk {
  ok: boolean;
  data: IGetUserPrivilegesResponseData;
}

export interface IPrivilegeListItem {
  code: PrivilegeCode;
  name: string;
}
export interface IGetPrivilegesListResponseOk {
  ok: boolean;
  data: IPrivilegeListItem[];
}

export interface IPostResponseItem {
  createdAt: Date;
  id: number;
  updatedAt: Date;
  user: string;
  enabled: boolean;
  privilege: IPostResponsePrivilege;
}

interface IPostResponsePrivilege {
  createdAt: Date;
  id: number;
  updatedAt: Date;
  code: string;
  name: string;
}

export interface IPostUserPrivileges extends BaseServiceRequestDto {
  data: {
    user: string;
    privileges: PrivilegeCode[];
  };
}

export interface IPostUserPrivilegesResponseOk {
  ok: boolean;
  data: IPostResponseItem[];
}

export enum PrivilegeCode {
  BTN_CONTRATA = "BTN_CONTRATA",
  BTN_EIAC = "BTN_EIAC",
  BTN_EXPIRADAS = "BTN_EXPIRADAS",
  BTN_RENOVACIONES = "BTN_RENOVACIONES",
  BTN_SIMULA = "BTN_SIMULA",
  BTN_SIMULA2 = "BTN_SIMULA2",
  BTN_SUPLEMENTO = "BTN_SUPLEMENTO",
  BTN_IMPAGADOS = "BTN_IMPAGADOS",
  CLIENTES = "CLIENTES",
  CM_CARTERAS = "CM_CARTERAS",
  CM_EIAC = "CM_EIAC",
  CM_RENOVACIONES = "CM_RENOVACIONES",
  CM_SIMULACIONES = "CM_SIMULACIONES",
  CM_SOLICITUDES = "CM_SOLICITUDES",
  CM_IMPAGADOS = "CM_IMPAGADOS",
  CONTRATA = "CONTRATA",
  CUADRO_MANDO = "CUADRO_MANDO",
  FICHEROS_EIAC = "FICHEROS_EIAC",
  INF_COMISION = "INF_COMISION",
  INF_DETFAC = "INF_DETFAC",
  INF_FACTURAS = "INF_FACTURAS",
  INF_POLIZAS = "INF_POLIZAS",
  INFORMES = "INFORMES",
  POLIZAS = "POLIZAS",
  REC_IMPAGADOS = "REC_IMPAGADOS",
  REC_PENDIENTES = "REC_PENDIENTES",
  RECIBOS = "RECIBOS",
  RECOBROS = "RECOBROS",
  SIMULA = "SIMULA",
  FORMACION = "FORMACION"
}

export interface IUpdatePrivilegesByFile extends BaseServiceRequestDto {
  file: File;
}

export interface FileContent {
  metadata: Metadata;
  content: string;
}

export interface Metadata {
  name: string;
  extension: string;
  size: number;
}

export interface IUpdatePrivilegesByFileResponseOk {
  ok: boolean;
  result: "exit" | "error";
  data: FileContent;
}
